import { Input } from 'antd';

function SearchBar({ onChange, style }) {
    return (
      <div
        style={{
          width: "350px",
          outline: "none",
          border: "none",
          padding: "4px 8px",
          borderRadius: "4px"
        }}
      >
        <Input
          placeholder="Search"
          onChange={onChange}
          style={{
            height: '40px', // Adjust this value to your preferred height
            padding: '8px 11px', // Optional: adjust padding for better appearance
            fontSize: '16px' // Optional: adjust font size if needed
          }}
        />
      </div>
    );
}

export default SearchBar;